'use client'
import { Popover, PopoverContent, PopoverProps, PopoverTrigger } from '@nextui-org/popover'

import { CSSProperties, FC, ReactNode, useState } from 'react'

import { IClassName } from '@/app/shared/interfaces/common.interface'

// interface
interface IPopover extends Omit<PopoverProps, 'children'>, IClassName {
  trigger: ReactNode
  hoverEvent?: boolean
  isOpen?: boolean
  onOpenChangeHandle?: (value: boolean) => void
  children: (setIsOpen: React.Dispatch<React.SetStateAction<boolean>>) => React.ReactNode
  styleParent?: CSSProperties
}

// component
const PopoverComponent: FC<Readonly<IPopover>> = ({
  children,
  trigger,
  hoverEvent,
  className,
  isOpen: isOpenProps,
  onOpenChangeHandle,
  styleParent,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(isOpenProps || false)

  const handleMouseClose = (status: boolean) => {
    if (!hoverEvent) return

    setIsOpen(status)
  }

  const handleOpen = (status: boolean) => {
    setIsOpen(status)

    if (onOpenChangeHandle) onOpenChangeHandle(status)
  }

  // return
  return (
    <Popover
      isOpen={isOpen}
      onOpenChange={handleOpen}
      placement='bottom'
      className={className}
      style={styleParent}
      {...props}
    >
      <PopoverTrigger
        className={'!scale-100 cursor-pointer !opacity-100'}
        onMouseEnter={() => handleMouseClose(true)}
        onMouseLeave={() => handleMouseClose(false)}
      >
        {trigger}
      </PopoverTrigger>
      <PopoverContent
        onMouseEnter={() => handleMouseClose(true)}
        onMouseLeave={() => handleMouseClose(false)}
      >
        {typeof children === 'function' ? children(setIsOpen) : null}
      </PopoverContent>
    </Popover>
  )
}

export default PopoverComponent
